import httpClient from './httpClient';

const AddOrUpdate = (model) => httpClient.post('/api/v2/SystemNotification/AddOrUpdate', model);


const GetAllSystemNotifications = (propertyId) => httpClient.get('/api/v2/SystemNotification/GetAllSystemNotifications', { params: { propertyId: propertyId } });

const MarkAsRead = (notificationId) => httpClient.post('/api/v2/SystemNotification/MarkAsRead', {}, { params: { notificationId: notificationId } });


export default {
  AddOrUpdate,
  GetAllSystemNotifications,
  MarkAsRead
}



// WEBPACK FOOTER //
// ./src/api/system-notification-api.js